import { cn } from "../lib/cn";

export interface ProgressBarProps {
  /** 0..1. Clamped, because a clutch can run past its expected day. */
  value: number;
  label: string;
  /**
   * `alarm` draws the bar in the error colour on its own tinted track, for a card that
   * is already red. The default track would disappear against that fill.
   */
  tone?: "default" | "alarm";
  className?: string;
}

/**
 * A single-track progress bar. Used for incubation and for a dosing course, where
 * "day 3 of 7" is the thing a breeder actually wants at a glance.
 */
export function ProgressBar({ value, label, tone = "default", className }: ProgressBarProps) {
  const clamped = Math.min(1, Math.max(0, value));

  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuenow={Math.round(clamped * 100)}
      aria-valuemin={0}
      aria-valuemax={100}
      className={cn(
        "h-2.5 w-full overflow-hidden rounded-full",
        tone === "alarm" ? "bg-error/20" : "bg-primary-fixed",
        className,
      )}
    >
      <div
        className={cn(
          "h-full rounded-full transition-[width] duration-300",
          tone === "alarm" ? "bg-error" : "bg-accent-mark",
        )}
        style={{ width: `${clamped * 100}%` }}
      />
    </div>
  );
}
